'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import clsx from 'clsx';
import { useState } from 'react';
import type { OfferingModalTypes } from '@/app/about/_types/offeringTypes';
import { useDeviceStore } from '@/store/about/deviceStore';
import { offeringContentMap } from './offeringContentMap';
import TabMenu from './TabMenu';
export default function OfferingModal(t0) {
  const $ = _c(38);
  const {
    isOpen,
    close,
    name,
    title,
    tabItem
  } = t0;
  const [tabIndex, setTabIndex] = useState(0);
  const {
    deviceType
  } = useDeviceStore();
  const deviceMap = deviceType === "desktop" ? offeringContentMap.desktop : offeringContentMap.mobile;
  const ContentComponent = deviceMap[name]?.[tabIndex];
  let t1;
  if ($[0] !== close) {
    t1 = open => !open && close();
    $[0] = close;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = deviceType === "mobile" ? "is_mobile" : "is_desktop";
  const t3 = `modal_offering modal_${name}`;
  let t4;
  if ($[2] !== t3) {
    t4 = clsx("wrap_modal dim_dark", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <Dialog.Title className="title">{title}</Dialog.Title>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Dialog.Description className="text_blind">이실장 서비스 주요기능을 설명하는 모달입니다.</Dialog.Description>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div className="headline">{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text_blind">닫기</span>;
    t9 = <i className="icon_close" />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== close) {
    t10 = <Dialog.Close asChild={true}><button className="btn_close" type="button" onClick={close}>{t8}{t9}</button></Dialog.Close>;
    $[11] = close;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t7) {
    t11 = <div className="modal_header">{t7}{t10}</div>;
    $[13] = t10;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== tabIndex || $[17] !== tabItem) {
    t12 = tabItem && <div className="wrap_tab"><TabMenu tabItem={tabItem} tabIndex={tabIndex} onTabClick={setTabIndex} /></div>;
    $[16] = tabIndex;
    $[17] = tabItem;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = `${name}_${tabIndex}`;
  let t14;
  if ($[19] !== ContentComponent) {
    t14 = ContentComponent && <ContentComponent />;
    $[19] = ContentComponent;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13 || $[22] !== t14) {
    t15 = <div className="modal_content" key={t13}>{t14}</div>;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t15) {
    t16 = <Dialog.Content className="modal">{t11}{t12}{t15}</Dialog.Content>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16 || $[29] !== t4) {
    t17 = <Dialog.Overlay className={t4}>{t16}</Dialog.Overlay>;
    $[28] = t16;
    $[29] = t4;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t2) {
    t18 = <Dialog.Portal><div className={t2}>{t17}</div></Dialog.Portal>;
    $[31] = t17;
    $[32] = t2;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isOpen || $[35] !== t1 || $[36] !== t18) {
    t19 = <Dialog.Root open={isOpen} onOpenChange={t1}>{t18}</Dialog.Root>;
    $[34] = isOpen;
    $[35] = t1;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
}